module.exports = __webpack_public_path__ + "static/media/default_emergency_room_md.621cb455.jpeg";